<template lang="pug">
.foot-slides
  empty-state(v-if="footprints.length < 1" copy="您还未体验")
  .swiper-container(ref="swiper" v-if="footprints.length > 0")
    .swiper-wrapper
      .swiper-slide(v-for="(ex, i) in footprints" :key="i")
        zoom-card(:idx="i" :total="footprints.length" :progress="progress" :transitioning="transitioning")
          .card
            component(
              :is="$t(`footprints.${ex.exhibitId}`).layout"
              :exp="ex"
            )
            //img(:src="ex.card")
    .swiper-pagination(ref="pagination")
  //.btn
    primary-btn(v-if="footprints.length > 0" type="genReport")
</template>
<script>
import Swiper from 'swiper'
import ZoomCard from './ZoomCard'
import { mapMutations, mapState } from 'vuex'
import EmptyState from '@/components/wedgits/EmptyState'
import PrimaryBtn from '@/components/wedgits/PrimaryBtn'
export default {
  name: 'FootSlides',
  components: { PrimaryBtn, EmptyState, ZoomCard },
  props: {},
  data() {
    return {
      progress: 0,
      transitioning: false,
    }
  },
  computed: {
    ...mapState('app', ['user']),
    footprints() {
      return this.user.exps
        ? [...this.user.exps[0].expDataSet, { exhibitId: '2' }]
        : []
    },
  },
  methods: {
    ...mapMutations('app', ['setRouterBack']),
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      pagination: {
        el: this.$refs.pagination,
      },
      on: {
        progress: (swiper, p) => {
          console.log(p)
          this.progress = p
        },
        transitionStart: () => {
          // if (this.swiper)
          //   console.log('trans', this.swiper.wrapperEl.style.transitionDuration)
          this.transitioning = true
        },
        transitionEnd: () => {
          console.log('trans end')
          this.transitioning = false
        },
      },
    })
  },
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.foot-slides
  width: 100%
  display: flex
  flex-direction: column
  align-items: center
  .swiper-container
    width: 100%
    overflow: visible
    .swiper-slide
      //background: #42b983
      width: pxToRem(582)
      height: pxToRem(867)
      .card
        width: 100%
        height: 100%
        border-radius: pxToRem(16)
        overflow: hidden
        box-shadow: 0 pxToRem(-1) pxToRem(10) 0 rgba(226,226,226,0.73)
        img
          //width: 100%
          height: 100%
          object-fit: cover

    .swiper-pagination
      position: relative
      top: pxToRem(0)
  .btn
    position: absolute
    bottom: pxToRem(40)
    width: 90%
</style>
